import styled from 'styled-components';
import { Typography } from '@hiiretail/synergy-ui';
import React from 'react';
import {
  GroupDtoStatusEnum,
  IdentityProviderDtoStatusEnum,
  TenantDtoStatusEnum,
  UserDtoStatusEnum,
} from '../../../api-client';
import { TypographyVariant } from '@hiiretail/synergy-ui/dist/types/components/content/Typography/Typography.types';

type IamStatus =
  | GroupDtoStatusEnum
  | UserDtoStatusEnum
  | IdentityProviderDtoStatusEnum
  | TenantDtoStatusEnum
  | 'Primary';

const StatusContainer = styled(Typography)<{ status: IamStatus }>`
  border-radius: 4px;
  padding: 4px 8px;
  display: flex;
  width: max-content;
  align-items: center;

  ${({ status }) =>
    status === 'Created' &&
    `
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
  `}

  ${({ status }) =>
    (status === 'Creating' || status === 'Linking' || status === 'Activating') &&
    `
    background: #DAEAFB;
    border: 1px solid #1D72D8;
  `}

  ${({ status }) =>
    (status === 'Updating' || status === 'Deactivating' || status === 'Inactivating') &&
    `
    background: #DAEAFB;
    border: 1px solid #1D72D8;
  `}

  ${({ status }) =>
    status === 'Inactive' &&
    `
    background: #FDEBF0;
    border: 1px solid #EB0A3F;
  `}

  ${({ status }) =>
    status === 'Primary' &&
    `
    background: #E1F9F0;
    border: 1px solid #06884C;
  `}
`;

type StatusComponent = React.FC<{
  status: IamStatus;
  variant: TypographyVariant;
}>;

export const Status: StatusComponent = ({ status, variant }) => (
  <StatusContainer variant={variant} status={status}>
    {status}
  </StatusContainer>
);
